module.exports = __webpack_public_path__ + "static/media/leite.127f6e73.m4a";